// Vue
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
// Template
import template from "./template.vue";
// Components
import { Icon } from "./../icon/Icon";
import { HttpService } from "../../../services/HttpService";
import { Select } from "../select/Select";
import { SelectOption } from "../select/option/SelectOption";
import { Button } from "../button/Button";
import { Link } from "../link/Link";
import { AttachmentDTO } from "../../../models/attachment/AttachmentDTO";
import { getIconFromFileType } from "../../../services/FileTypeToIconService";

interface SelectOptionData {
  id: string | number;
  name: string;
  disabled: boolean;
}

interface FileStatusInformationState {
  id: string | number;
  name: string;
}

interface FileStatusInformation {
  archived: boolean;
  version: string | number;
  deleted: boolean;
  versionedFilename: string;
  file: AttachmentDTO;
  state: FileStatusInformationState;
}

@Component({
  name: "TechdocSelectList",
  components: {
    Select,
    SelectOption,
    Icon,
    Button,
    Link,
  },
  mixins: [template],
})
export class TechdocSelectList extends Vue {
  private readonly http: HttpService = HttpService.instance;

  @Prop({ default: "/portal/apps/techdoc/ajax/reloadtechdocs.json" })
  public refreshUrl!: string;

  @Prop({ default: "/portal/apps/techdoc/ajax/{id}.json" })
  public fileStatusUrl!: string;

  @Prop()
  public abhEinheitId!: number;

  @Prop()
  public vehicleTypeId!: number;

  @Prop()
  public solution!: string | (string | number)[];

  @Prop()
  public csrf!: string;

  @Prop()
  public type!: string;

  @Prop()
  public name!: string;

  @Prop({ default: [] })
  public value!: (string | number)[];

  private options: SelectOptionData[] = [];

  private fileStatusInforamtion: { [key: string]: FileStatusInformation } = {};

  @Watch("selectedOptions")
  private onValueChange() {
    this.selectedOptions.forEach((v) => {
      if (!this.fileStatusInforamtion[v.id]) {
        this.getFileStatusInformation(v);
      }
    });
  }

  protected onValueSelected(selectedValue) {
    let foundOption = this.options.find((option) => option.id == selectedValue);

    if (foundOption) {
      Vue.delete(this.fileStatusInforamtion, foundOption.id);

      let value = this.value.slice();
      value.push(foundOption.id);
      this.$emit("input", value);
    }
  }

  public mounted() {
    this.refreshSelectItems();
  }

  get finalOptions() {
    return this.options.filter((option) => {
      return !this.value.includes(option.id);
    });
  }

  get selectedOptions() {
    return this.options.filter((option) => {
      return this.value.includes(option.id);
    });
  }

  public onDeleteClick(id) {
    this.$emit(
      "input",
      this.value.filter((valueId) => valueId != id)
    );
  }

  public async refreshSelectItems() {
    let response = await this.http.post<SelectOptionData[]>(this.refreshUrl, {
      abhId: this.abhEinheitId,
      vehicleTypeId: this.vehicleTypeId,
      type: this.type,
      csrf: this.csrf,
      solution: this.solution,
    });

    this.options = response.body!;
  }

  public async getFileStatusInformation(option: SelectOptionData) {
    try {
      let url = this.fileStatusUrl.replace("{id}", <string>option.id);
      let response = await this.http.get<FileStatusInformation>(url);
      Vue.set(this.fileStatusInforamtion, option.id, response.body!);
    } catch (e) {
      Vue.set(this.fileStatusInforamtion, option.id, {
        archived: false,
        version: "",
        deleted: false,
        versionedFilename: option.name,
        file: null,
        state: {
          id: -1,
          name: "No access",
        },
      });
    }
  }

  protected getIconStatus(fileInfo: FileStatusInformation) {
    if (fileInfo.archived) {
      return "archived";
    } else {
      switch (fileInfo.state.id) {
        case 2:
        case "2":
          return "geprueft-und-freigegeben";
        case 3:
        case "3":
          return "geprueft-und-abgelehnt";
        default:
          return "ungeprueft";
      }
    }
  }

  protected getMimeTypeIcon(mimeType: string) {
    return getIconFromFileType(mimeType);
  }
}
